const kddi = require('./configs/kddi.config');

const solutoConfig = {
  kddi
};

module.exports = solutoConfig;
